import React from "react";
import {
  selectMapSampleSize,
  selectTableSampleSize,
} from "../Util/Analytics/InteractionAnalytics";

/**
 * SampleSizeToggle
 *
 * Simple reusable checkbox + label pair used to toggle
 * display of sample size columns in table visualizations.
 */
const SampleSizeToggle = ({
  id = "showSampleSizeCheckbox",
  checked,
  onChange,
  className = "sample-size-toggle",
  labelClassName = "form-check-label ml-2 sample-size-label",
  inputClassName = "form-check-input sample-size-checkbox",
}) => {
  const handleChange = (e) => {
    if (id === "tableShowSampleSizeCheckbox") {
      selectTableSampleSize();
    } else if (id === "mapShowSampleSizeCheckbox") {
      selectMapSampleSize();
    }

    if (typeof onChange === "function") {
      onChange(e.target.checked);
    }
  };

  return (
    <div className={className}>
      <div
        className="form-check d-inline-flex align-items-center justify-content-end"
        style={{ whiteSpace: "nowrap" }}
      >
        <input
          className={inputClassName}
          type="checkbox"
          id={id}
          checked={!!checked}
          onChange={handleChange}
        />
        <label className={labelClassName} htmlFor={id}>
          Show Sample Size
        </label>
      </div>
    </div>
  );
};

export default SampleSizeToggle;
